import { render, staticRenderFns } from "./MeatNewData.vue?vue&type=template&id=643122ea"
import script from "./MeatNewData.vue?vue&type=script&lang=js"
export * from "./MeatNewData.vue?vue&type=script&lang=js"
import style0 from "./MeatNewData.vue?vue&type=style&index=0&id=643122ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports